const PLAIN = /^(\d+)(\.\d*)?$/

/**
 * Thousands separators for a number the app already formatted as a plain decimal string: "350085774" -> "350,085,774",
 * "1234.5678" -> "1,234.5678". Display only (site review 59, 2026-10-07): it never rounds and never changes a digit, so
 * removing the commas gives back the input. Anything that is not a plain non-negative decimal ("", "-", "<0.001", "1e+21",
 * an already grouped string) comes back as it is.
 */
export function groupDigits(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return ''
  const s = String(value)
  const m = PLAIN.exec(s)
  if (!m) return s
  return `${m[1].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${m[2] ?? ''}`
}

/** groupDigits for a formatted amount that may be missing: undefined stays undefined, so `?? '-'` fallbacks keep working. */
export const grouped = (formatted: string | undefined): string | undefined => (formatted === undefined ? undefined : groupDigits(formatted))
